import type { BlockTool, BlockToolConstructorOptions, SanitizerConfig } from '@editorjs/editorjs';

interface CenteredTextBlockData {
  text: string;
}

interface CenteredTextBlockConfig {
  placeholder?: string;
}

export default class CenteredTextBlock implements BlockTool {
  private api: BlockToolConstructorOptions['api'];
  private data: CenteredTextBlockData;
  private config: CenteredTextBlockConfig;
  private container!: HTMLDivElement;
  private placeholder: string;

  constructor({
    data,
    config,
    api,
  }: BlockToolConstructorOptions<CenteredTextBlockData, CenteredTextBlockConfig>) {
    this.api = api;
    this.data = {
      text: data?.text || '',
    };
    this.config = config || {};
    this.placeholder = this.config.placeholder || '';
  }

  static get toolbox() {
    return {
      title: 'Centered Text',
      icon: '<svg width="20" height="20"><text x="4" y="14">T</text></svg>',
    };
  }

  render(): HTMLDivElement {
    this.container = document.createElement('div');
    this.container.contentEditable = 'true';
    this.container.dataset.placeholder = this.placeholder;
    this.container.innerHTML = this.data.text;
    this.container.classList.add('ce-centered-paragraph'); // optional

    return this.container;
  }

  save(blockContent: HTMLElement): CenteredTextBlockData {
    return {
      text: blockContent.innerHTML,
    };
  }

  validate(savedData: CenteredTextBlockData): boolean {
    return savedData.text.trim() !== '';
  }

  static get isReadOnlySupported(): boolean {
    return true;
  }

  static get contentEditable(): boolean {
    return true;
  }

  static get sanitize(): SanitizerConfig {
    return {
      text: {}, // allow basic HTML
    };
  }
}
